import Index from './components/Index.vue'
import Detail from './components/Detail.vue'
import Foundation from './components/Foundation.vue'
import FoundationTv from "./components/FoundationTv.vue";
import fanzha from "./components/fanzha.vue";
import Succeed from './components/Succeed.vue'
import Search from './components/Search.vue'
import paySucceed from './components/paySucceed.vue'

const routers = [{
        path: "/",
        name: "index",
        component: Index
    },
    {
        path: "/detail",
        name: "detail",
        component: Detail
    },
    {
        path: "/foundation",
        name: "foundation",
        component: Foundation
    },
    {
        path: "/succeed",
        name: "succeed",
        component: Succeed
    },
    {
        path: "/paySucceed",
        name: "paySucceed",
        component: paySucceed
    },
    {
        path: "/foundationtv",
        name: "foundationtv",
        component: FoundationTv
    },
    {
        path: "/fanzha",
        name: "fanzha",
        component: fanzha
    },
    {
        path: "/search",
        name: "search",
        component: Search
    }
];
export default routers